import { useMemo } from 'react'
import { encodeQr } from '../lib/qrcode'

// Sfondo bianco e moduli neri sono voluti: un QR code deve avere contrasto pieno per essere letto, in qualsiasi tema.

interface Props {
  /** The text to encode — for MFA enrollment, the `otpauth://` URI. Never persisted by this component. */
  value: string
  /** Rendered pixel size (square). */
  size?: number
  className?: string
}

/**
 * F-040 / REQ-032-002. Renders `value` as a QR code using this repo's own encoder
 * (`src/lib/qrcode.ts` — no npm dependency, see that file's remarks). Inline SVG rather than
 * canvas: crisp at any size, themeable via CSS (`currentColor`), and nothing to clean up on
 * unmount.
 */
export function QrCode({ value, size = 200, className }: Props) {
  const { matrix, size: modules } = useMemo(() => encodeQr(value), [value])

  // One quiet-zone module of margin on every side, per ISO/IEC 18004 §5.3.2 (a QR code with too
  // little white border around it can fail to scan).
  const quietZone = 4
  const viewBoxSize = modules + quietZone * 2

  let path = ''
  for (let row = 0; row < modules; row++) {
    for (let col = 0; col < modules; col++) {
      if (matrix[row][col]) {
        path += `M${col + quietZone},${row + quietZone}h1v1h-1z`
      }
    }
  }

  return (
    <svg
      role="img"
      aria-label="Codice QR per l'app di autenticazione"
      className={className ? `md-u-qr mw-100 h-auto ${className}` : 'md-u-qr mw-100 h-auto'}
      width={size}
      height={size}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      shapeRendering="crispEdges"
    >
      <path d={path} fill="#000" />
    </svg>
  )
}
